<template>
  <b-modal
    id="insert-form-document-link-modal"
    :title="trans('insert_link_form_document' + (this.organization.has_amilia ? '_amilia' : ''))"
    :ok-title="trans('insert')"
    :ok-disabled="!url"
    :cancel-title="trans('cancel')"
    @hidden="onHidden"
    @ok="onInsert"
  >
    <b-form-group>
      <b-form-radio-group v-model="mode" :options="modeOptions">
      </b-form-radio-group>
    </b-form-group>
    <b-form-group>
      <form-dropdown
        v-if="mode == 'form'"
        :organization="organization"
        v-model="recipient_form_id"
        :initial_page_url="initial_url"
        :placeholder="trans('choose_a_form')"
        nullable
        mode="forms"
        @list="onSelectForm"
      />
      <div v-if="mode == 'document'">
        <document-dropdown
          :organization="organization"
          v-model="document_id"
          :initial_short_url="initial_url"
          nullable
          @document="onSelectDocument"
        ></document-dropdown>
        <div class="text-center">
          <em>{{ trans('or') }}</em>
        </div>
        <b-form-group :label="trans('upload')">
          <b-form-file
            v-model="upload_file"
            :placeholder="trans(organization.allow_non_pdf_document_upload ? 'upload_document' : 'upload_pdf')"
            :drop-placeholder="trans('drop_file_here')"
            :accept="organization.allow_non_pdf_document_upload ? '.pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx' : 'application/pdf'"
            :disabled="busy"
            @input="onDocumentFileChange(null)"
          />
          <b-form-text>
            {{ trans('documents_can_be_managed') }}
          </b-form-text>
        </b-form-group>
        <p v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          {{ trans('please_wait') }}
        </p>
        <p v-if="error" class="text-danger">
          {{ error }}
        </p>
      </div>
      <div v-if="mode == 'page'">
        <page-dropdown
          :organization="organization"
          v-model="page_id"
          :initial_short_url="initial_url"
          nullable
          @page="onSelectPage"
          :disabled="busy"
        ></page-dropdown>
      </div>
    </b-form-group>
    <div v-if="organization.has_amilia && mode == 'amilia_activity'">
      <choose-amilia-activity      
        :organization="organization"
        @activity="onSelectAmiliaActivity"
        :all-programs="all_programs"
        @all-programs="all_programs = $event"
      >
      </choose-amilia-activity>
      <small v-if="amiliaActivityUrl" class="d-block">
        <a :href="amiliaActivityUrl" target="_blank">
          {{ amiliaActivityName }}
          <i class="fa fa-fw fa-external-link-alt"></i>
        </a>
      </small>
    </div>
  </b-modal>
</template>
<script>
  import FormDropdown from './../list/ListDropdown'
  import DocumentDropdown from './../media/DocumentDropdown'
  import PageDropdown from './../page/PageDropdown'
  import ChooseAmiliaActivity from './../amilia/ChooseAmiliaActivity'

  window.insertFormDocumentLinkModalActiveEditor = null

  export default {
    props: {
      organization: Object,
      initial_url: String,
    },
    components: {
      FormDropdown,
      DocumentDropdown,
      PageDropdown,
      ChooseAmiliaActivity,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        text: null,
        url: null,
        mode: 'form',
        modeOptions: _.compact([
          {text: trans('form'), value: 'form'},
          {text: trans('document'), value: 'document'},
          {text: trans('page'), value: 'page'},
          this.organization.has_amilia ? {text: trans('amilia_activity'), value: 'amilia_activity'} : null,
        ]),
        recipient_form_id: null,
        recipient_form: null,
        document_id: null,
        amilia_activity: null,
        all_programs: null,
        upload_file: null,
        page_id: null,
      }
    },
    computed: {
      amiliaActivityName() {
        if (!this.amilia_activity) return null
          return _.compact([
            this.amilia_activity.name,
            this.amilia_activity.schedule_summary,
            trans('start') + ' ' + moment(this.amilia_activity.start).format('LL'),
          ]).join(', ')
      },
      amiliaActivityUrl() {
        if (!this.amilia_activity) return null
        return this.amilia_activity.url
      },
    },
    methods: {
      onDocumentFileChange() {
        if (!this.upload_file) return
        const url = `/organization/${this.organization.id}/media/document`
        this.busy = true
        this.error = null
        let formData = new FormData();
        formData.append("file", this.upload_file);
        axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          this.busy = false
          this.document_id = response.data.id
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onHidden() {
        this.amilia_activity = null
      },
      onSelectForm(recipient_form) {
        if (this.document_id) this.document_id = null
        if (this.amilia_activity) this.amilia_activity = null
        if (this.page_id) this.page_id = null
        this.url = recipient_form ? recipient_form.page_url : null
        this.text = recipient_form ? recipient_form.name : null
        this.recipient_form = recipient_form
      },
      onSelectDocument(doc) {
        if (this.recipient_form_id) this.recipient_form_id = null
        if (this.amilia_activity) this.amilia_activity = null
        if (this.page_id) this.page_id = null
        this.url = doc ? doc.short_url : null
        this.text = doc ? doc.name : null
        this.document = doc
      },
      onSelectAmiliaActivity(amilia_activity) {
        if (this.document_id) this.document_id = null
        if (this.recipient_form_id) this.recipient_form_id = null
        this.amilia_activity = amilia_activity
        this.url = this.amiliaActivityUrl
        this.text = this.amiliaActivityName
      },
      onSelectPage(page) {
        if (this.recipient_form_id) this.recipient_form_id = null
        if (this.amilia_activity) this.amilia_activity = null
        if (this.document_id) this.document_id = null
        this.url = page ? page.short_url : null
        this.text = page ? page.name : null
        this.page = page
      },
      onInsert() {
        const editor = window.insertFormDocumentLinkModalActiveEditor
        editor.model.change(writer => {
          const linkedText = writer.createText(this.text, {linkHref: this.url})
          editor.model.insertContent(linkedText, editor.model.document.selection)
          this.$bvModal.hide('insert-form-document-link-modal')
        })
      },
    },
    mounted() {
      window.insertFormDocumentLinkModal = this
    },
    // static method
    buildSimpleButton(component) {
      return {
          name: 'insertFormDocumentLink',
          label: trans('insert_link_form_document' + (component && component.organization && component.organization.has_amilia ? '_amilia' : '')),
          icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zm-22.6 22.7c2.1 2.1 3.5 4.6 4.2 7.4H256V32.5c2.8.7 5.3 2.1 7.4 4.2l83.9 83.9zM336 480H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h176v104c0 13.3 10.7 24 24 24h104v304c0 8.8-7.2 16-16 16zm-48-244v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm0 64v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12z"/></svg>',
          syncDisabledState: false,
          onClick: (buttonView, editor) => {
            window.insertFormDocumentLinkModalActiveEditor = editor
            component.$bvModal.show('insert-form-document-link-modal')
          },
      }
    },
  }
</script>